export default __webpack_public_path__ + "static/countdown_widget_collapsed-fa6c8b0d84b3534c05b8aebff0812191.png";